import { ReactNode } from 'react';
import { Typography } from '../../../../core/components/molecules/Typography';
import { RadioInput } from './variants';

interface ICustomRadio {
  children: ReactNode;
  value: string;
  checked: string;
  helper?: string;
  setData: (value: string) => void;
}

const CustomRadio: React.FC<ICustomRadio> = ({
  children,
  value,
  helper,
  setData,
  checked,
}) => {
  return (
    <div>
      <div className='flex flex-row items-center gap-md'>
        <input
          id={`practice-area-${value}`}
          type='radio'
          value={value}
          checked={checked === value}
          onChange={() => setData(value)}
          className={RadioInput({ type: 'default' })}
        />
        <label className='w-full hover:cursor-pointer'>{children}</label>
      </div>
      {helper && (
        <div className='ml-8'>
          <Typography size='small'>{helper}</Typography>
        </div>
      )}
    </div>
  );
};

export default CustomRadio;
